import React, { useState } from 'react'
import { makeStyles, Divider, Typography, FormControl, MenuItem, Select, Box, Tooltip, Menu } from "@material-ui/core";
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import VideocamOutlinedIcon from '@material-ui/icons/VideocamOutlined';
import { green, } from '@material-ui/core/colors'
import clsx from 'clsx';
import QuizIcon from '../../../sharedComponents/customIcons/QuizIcon';
import DescriptionIcon from '@material-ui/icons/Description';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import DialogComponent from '../commonComponents/DialogComponent';
import DocumentViewer from "../commonComponents/DocumentViewer";


const useStyles = makeStyles((theme) => ({
    listSecondaryText: {
        fontSize: '0.65rem',
        lineHeight: '1',
        letterSpacing: 'normal',

    },
    activeSection: {
        backgroundColor: (obj) => obj.isActive ? green[50] : '#ffffff',
        '&:hover': {
            backgroundColor: (obj) => obj.isActive ? green[50] : '#ffffff',
        },
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 150,
        '& .MuiOutlinedInput-root': {
            height: '30px'
        }
    },
    nested: {
        width: (obj) => obj.hasResource ? '50%' : '100%',
        paddingRight: '16px',
        '& .MuiListItemText-root': {
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'

        }
    }

}));


const SubSectionView = ({ sectionId, activeSubId, item, onSectionContentShowClick, completedSubIds, disabled, isComplete, handleViewDocument }) => {
    const classes = useStyles({ hasResource: item?.resources.length > 0 ? true : false, isActive: item.sectionID == activeSubId ? true : false });
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    
    const handleResourceClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onDocumentClick = (docName) => {
        handleViewDocument(docName);
    }

    const getContentIcon = () => {
        if (item.sectionTypeName == 'Quiz') {
            return <QuizIcon />
        }
        let type = item?.documentName?.split('.')?.pop();
        switch (type) {

            case 'video':
            case 'mov':
            case 'mp4':
                return <VideocamOutlinedIcon />
            case 'pdf':
                return <PictureAsPdfIcon />
            case 'xlx':
            case 'xlsx':
            case 'doc':
            case 'docx':
            case 'ppt':
            case 'pptx':
                return <DescriptionIcon />
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'svg':
                return <ImageOutlinedIcon />
            default:
                return <></>
        }
    }
    return (
        <Tooltip title={item.sectionName}>
            <Box component='div' className={clsx({ [classes.activeSection]: true })}>
                <ListItem button disabled={disabled} className={clsx({ [classes.nested]: true })} onClick={() => onSectionContentShowClick(sectionId, item)}>
                    <ListItemIcon>
                        <Checkbox
                            size="small"
                            edge="start"
                            tabIndex={-1}
                            disableRipple
                            checked={isComplete}
                        //!disabled && item.sectionID != activeSubId
                        />
                    </ListItemIcon>
                    <ListItemText primary={<Typography variant="subtitle2" >{item.sectionName}</Typography>} secondary={<Typography variant="caption" className={classes.listSecondaryText}>{item?.shortDescription}</Typography>} />
                    <ListItemSecondaryAction>
                        <Box component='div' display='flex' justifyContent='flex-end' width='180px' alignItems='center'>
                            <IconButton
                                onClick={handleResourceClick}
                                aria-label="more"
                                aria-controls="demo-simple-select-outlined"
                                aria-haspopup="true"
                                disabled={disabled}
                                style={{ visibility: (item?.resources && item?.resources.length > 0) ? 'visible' : 'hidden', margin: '5px' }}
                            >
                                <FolderOpenIcon />
                            </IconButton>
                            <Menu
                                elevation={0}
                                id="demo-simple-select-outlined"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                            // PaperProps={{
                            //     style: {
                            //         maxHeight: ITEM_HEIGHT * 4.5,
                            //         width: '20ch',
                            //     },
                            // }}
                            >
                                {item?.resources.map((res, i) => <MenuItem onClick={() => onDocumentClick(res.resourceName)}>{res.resourceTitle} </MenuItem>)}
                            </Menu>

                            {getContentIcon()}
                        </Box>
                    </ListItemSecondaryAction>
                </ListItem>
                <Divider />               
            </Box>
        </Tooltip>

    )
}
export default SubSectionView